import Actions                     from 'Redux/Actions';
import { ofType }                  from 'redux-observable';
import { from }                    from 'rxjs';
import { mergeMap, catchError }    from 'rxjs/operators';
import { TEpic }                   from 'Redux/Config';
import { EventCategoryRepository } from 'Domain/Repositories';
import { message }                 from 'antd';

export const createEventCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.createEventCategoryRequest.type),
    mergeMap(action => from(EventCategoryRepository.create(action.payload.formData))
      .pipe(
        mergeMap((eventCategory) => {
          message.success('Event Kategorie wurde erfolgreich erstellt');
          return from([
            Actions.createEventCategorySuccess({ eventCategory })
          ]);
        }),
        catchError(error => {
          return from([
            Actions.createEventCategoryFailure({ error }),
          ]);
        })
      )
    ),
  );
};
